import React from "react";

const ContactMap = () => {
  return (
    // Google Map
    <div className="flex justify-center items-center mx-4 md:mx-8 lg:mx-16 h-[50vh] md:h-[70vh]">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3730.431020754655!2d86.14953917529418!3d20.773843480812467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a195b8cd2a9e6fd%3A0xd38fd2f1aa3219a7!2sSR%20MARKET%20COMPLEX!5e0!3m2!1sen!2sin!4v1736512816603!5m2!1sen!2sin"
        width="1340"
        height="530"
        style={{ border: 0 }}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        className="w-full h-full rounded-3xl"
      ></iframe>
    </div>
  );
};

export default ContactMap;
